import { useState } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta5({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const [seleccionadas, setSeleccionada] = useState([]);
	const [btn1, setBtn1] = useState(false);
	const [btn2, setBtn2] = useState(false);
	const [btn3, setBtn3] = useState(false);
	const [btn4, setBtn4] = useState(false);
	const [correctas] = useState(['a) Crear recordatorios visibles.', 'c) Rediseñar procesos para simplificar tareas.', 'd) Ofrecer recompensas simbólicas.']);

	const grabarSeleccionada = (opc) => {
		const array = seleccionadas;
		array.push(opc);
		array.sort();
		setSeleccionada(array);
	};

	const siguiente = () => {
		if (seleccionadas.toString() === correctas.toString()) {
			setRespuesta('pregunta5', seleccionadas, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta5', seleccionadas, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(6);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>5.</div> ¿Qué estrategias de Nudging son efectivas para mejorar el desempeño de un Asesor desde una gestión remota? Selecciona todas las que apliquen:{' '}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn1 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn1(!btn1);
								grabarSeleccionada('a) Crear recordatorios visibles.');
							}}
						>
							<div className='letra'>{`a)`}</div>
							<div className='texto-respuesta'>Crear recordatorios visibles.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn2 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn2(!btn2);
								grabarSeleccionada('b) Incrementar la carga de trabajo para mayor presión.');
							}}
						>
							<div className='letra'>{`b)`}</div>
							<div className='texto-respuesta'>Incrementar la carga de trabajo para mayor presión.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn3 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn3(!btn3);
								grabarSeleccionada('c) Rediseñar procesos para simplificar tareas.');
							}}
						>
							<div className='letra'>{`c)`}</div>
							<div className='texto-respuesta'> Rediseñar procesos para simplificar tareas.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div
							className={`${btn4 ? 'disable' : ''} texto-pregunta`}
							onClick={() => {
								setBtn4(!btn4);
								grabarSeleccionada('d) Ofrecer recompensas simbólicas.');
							}}
						>
							<div className='letra'>{`d)`}</div>
							<div className='texto-respuesta'> Ofrecer recompensas simbólicas.</div>
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
